import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { env } from '#lib';

type TagOperation = {
  tagId: string;
  operation: 'add' | 'remove';
};

type State = {
  tags: TagOperation[];
};

type Actions = {
  addTag: (tagId: string) => void;
  removeTag: (tagId: string) => void;
  resetTag: (tagId: string) => void;
  reset: () => void;

  getPayload: () => { tagIdsToAdd: string[]; tagIdsToRemove: string[] };
};

type TagsSelectionStore = State & Actions;

export const useTagsSelectionStore = create<TagsSelectionStore>()(
  devtools(
    (set, get) => ({
      tags: [],

      addTag: tagId => {
        const { tags } = get();

        const filteredTags = tags.filter(t => t.tagId !== tagId);

        set({
          tags: [...filteredTags, { tagId, operation: 'add' }]
        });
      },

      removeTag: tagId => {
        const { tags } = get();

        const filteredTags = tags.filter(t => t.tagId !== tagId);

        set({
          tags: [...filteredTags, { tagId, operation: 'remove' }]
        });
      },

      resetTag: tagId => {
        const { tags } = get();

        set({
          tags: tags.filter(t => t.tagId !== tagId)
        });
      },

      reset: () => {
        set({ tags: [] });
      },

      getPayload: () => {
        const { tags } = get();

        return {
          tagIdsToAdd: tags
            .filter(t => t.operation === 'add')
            .map(t => t.tagId),
          tagIdsToRemove: tags
            .filter(t => t.operation === 'remove')
            .map(t => t.tagId)
        };
      }
    }),
    {
      name: 'useTagsSelectionStore',
      enabled: env.isDev()
    }
  )
);
